import useTheme from "@material-ui/core/styles/useTheme";
import { getImageSrc } from "../themes";
export const useImageSrc = imageName => {
  const activeTheme = useTheme();
  return getImageSrc(imageName, activeTheme.name);
};